module.exports = __webpack_public_path__ + "static/media/bubblehover.126a2d9a.png";